"use client";

import { useState, useEffect } from "react";
import { useRouter } from "next/navigation";
import posthog from "posthog-js";
import { ArrowRight } from "@phosphor-icons/react";
import Link from "next/link";
import { createSearchParams } from "@/app/onboarding/searchParamsHelper";
type BuyerType = "buyer" | "investor" | null;

export const OnboardingForm = () => {
  const router = useRouter();
  const [buyerType, setBuyerType] = useState<BuyerType>(null);
  const [hasSavedSearch, setHasSavedSearch] = useState(false);

  useEffect(() => {
    const savedSearch = localStorage.getItem("onboardingData");
    if (savedSearch) {
      setHasSavedSearch(true);
    }
  }, []);

  const handleSelection = (type: BuyerType) => {
    setBuyerType(type);
    posthog.capture("onboarding_buyer_type_selected", { type });
    router.push("/onboarding");
  };

  return (
    <div className="w-full mx-auto py-6">
      <div className="space-y-6">
        <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
          <button
            onClick={() => handleSelection("buyer")}
            className="btn btn-primary border-none text-white font-semibold h-14 md:h-16 px-8 rounded-lg transition-all duration-300 transform hover:scale-105 hover:shadow-lg text-base md:text-lg w-full"
          >
            I want to buy a Home
          </button>
          <Link href="/list/hyderabad">
            <button
              onClick={() => handleSelection("investor")}
              className="btn btn-neutralhover:bg-opacity-90 text-primary border-none font-semibold h-14 md:h-16 px-8 rounded-lg transition-all duration-300 transform hover:scale-105 hover:shadow-lg text-base md:text-lg w-full"
            >
              See handpicked homes
            </button>
          </Link>
        </div>
        {hasSavedSearch && (
          <div className="bg-blue-100 text-blue-800 p-2 rounded-lg text-center mb-2">
            <button
              onClick={() => {
                const savedSearch = localStorage.getItem("onboardingData");
                if (savedSearch) {
                  const { location, budget, propertyType, possession, buyerType } = JSON.parse(savedSearch);
                  const searchParams = createSearchParams(location, budget, propertyType, possession);
                  router.push(`/search?${searchParams.toString()}`);
                } else {
                  router.push("/onboarding");
                }
              }}
              className="underline font-semibold flex items-center justify-center gap-1 text-sm cursor-pointer hover:text-blue-600 transition-colors"
            >
              Continue your previous search <ArrowRight className="w-4 h-4" />
            </button>
          </div>
        )}
      </div>
    </div>
  );
};

export default OnboardingForm;
